import linkifyStr from "linkify-string";
const Linkify = (text) => {
  return linkifyStr(text, {
    defaultProtocol: "https",
    target: "_blank",
    className: "external linkified",
    attributes: {
      rel: "nofollow noopener noreferrer"
    }
  });
};
export {
  Linkify as L
};
